import { render, staticRenderFns } from "./ControlPanelBlock.vue?vue&type=template&id=08212cd6&scoped=true&"
import script from "./ControlPanelBlock.vue?vue&type=script&lang=js&"
export * from "./ControlPanelBlock.vue?vue&type=script&lang=js&"
import style0 from "./ControlPanelBlock.vue?vue&type=style&index=0&id=08212cd6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08212cd6",
  null
  
)

export default component.exports